import React from "react";
import "./styles.scss";

export default props => <div className="underline" />;
